import { render } from "./ContactCards.vue?vue&type=template&id=371800b8"
import script from "./ContactCards.vue?vue&type=script&lang=js"
export * from "./ContactCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__